import { render, staticRenderFns } from "./HomeProjSystem.vue?vue&type=template&id=3c1706ac&scoped=true&"
import script from "./HomeProjSystem.vue?vue&type=script&lang=ts&"
export * from "./HomeProjSystem.vue?vue&type=script&lang=ts&"
import style0 from "./HomeProjSystem.vue?vue&type=style&index=0&id=3c1706ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1706ac",
  null
  
)

export default component.exports